import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import {
  isIndentable,
  isOutdentable,
  onPointerDown,
  toggleIndent,
} from './EditorTextArea.utils';
import { getIcon } from './Icon';

type IndentButtonProps = {
  direction: 'indent' | 'outdent';
};

const IndentListButton = ({ direction }: IndentButtonProps) => {
  const editor = useSlate();

  if (
    (direction === 'outdent' && !isOutdentable(editor)) ||
    (direction === 'indent' && !isIndentable(editor))
  ) {
    return null;
  }

  return (
    <Button
      data-test-id={`indent-button-${direction}`}
      ghost
      icon={getIcon(direction)}
      onClick={() => toggleIndent(editor, direction)}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default IndentListButton;
